import 'regenerator-runtime/runtime';
import {AppRegistry} from 'react-native';
import App from '../src/App';

AppRegistry.registerComponent('AmazonKidsCreatorStudio', () => App);
AppRegistry.runApplication('AmazonKidsCreatorStudio', {
  rootTag: document.getElementById('root'),
});
